







import { Component, Vue, Prop } from 'vue-property-decorator'
import AppBar from '@/components/AppBar.vue'

@Component<ChecklistsLayout>({
  components: {
    AppBar
  }
})
export default class ChecklistsLayout extends Vue {
  get showAppBar() {
    return this.$route.path === '/' || this.$route.name === `login`
      ? false
      : true
  }
}
